/* KBF hard-coded mega menu (replaces Meteor Mega Menu app). Click a top item to open its photo panel. */
(function () {
  function eager(panel) {
    if (!panel || panel.dataset.kbfLoaded) return;
    panel.dataset.kbfLoaded = '1';
    panel.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }

  function initDesktop(nav) {
    if (nav.dataset.kbfReady) return;
    nav.dataset.kbfReady = '1';
    var toggles = Array.prototype.slice.call(nav.querySelectorAll('[data-kbf-mm-toggle]'));
    var openToggle = null;

    function panelFor(t) { return document.getElementById(t.getAttribute('aria-controls')); }

    function close() {
      if (!openToggle) return;
      var p = panelFor(openToggle);
      openToggle.setAttribute('aria-expanded', 'false');
      if (p) { p.hidden = true; p.classList.remove('is-open'); }
      openToggle = null;
    }

    function open(t) {
      close();
      var p = panelFor(t);
      if (!p) return;
      eager(p);
      p.hidden = false;
      var top = p.getBoundingClientRect().top;
      p.style.maxHeight = Math.max(240, window.innerHeight - top - 1) + 'px';
      p.classList.add('is-open');
      t.setAttribute('aria-expanded', 'true');
      openToggle = t;
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        if (openToggle === t) { close(); } else { open(t); }
      });
      /* warm up the photos as soon as the shopper points at the item */
      t.addEventListener('pointerenter', function () { eager(panelFor(t)); }, { once: true });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' && openToggle !== t) { e.preventDefault(); open(t); }
      });
    });

    document.addEventListener('click', function (e) {
      if (!openToggle) return;
      var p = panelFor(openToggle);
      if (openToggle.contains(e.target) || (p && p.contains(e.target))) return;
      close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openToggle) { var t = openToggle; close(); t.focus(); }
    });
  }

  function initMobile(root) {
    if (root.dataset.kbfReady) return;
    root.dataset.kbfReady = '1';
    var current = null;
    root.querySelectorAll('[data-kbf-mm-open]').forEach(function (btn) {
      btn.addEventListener('keydown', function (e) { if (e.key === ' ') { e.preventDefault(); btn.click(); } });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var p = document.getElementById(btn.getAttribute('data-kbf-mm-open'));
        if (!p) return;
        eager(p);
        p.hidden = false;
        root.classList.add('is-sub');
        btn.setAttribute('aria-expanded', 'true');
        current = btn;
        var back = p.querySelector('[data-kbf-mm-back]');
        if (back) back.focus();
        var scroller = root.closest('.menu-drawer__inner-container') || root.closest('.menu-drawer');
        if (scroller) scroller.scrollTop = 0;
      });
    });
    root.querySelectorAll('[data-kbf-mm-back]').forEach(function (b) {
      b.addEventListener('keydown', function (e) { if (e.key === ' ') { e.preventDefault(); b.click(); } });
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var p = b.closest('.kbf-mm-m__panel');
        if (p) p.hidden = true;
        root.classList.remove('is-sub');
        if (current) { current.setAttribute('aria-expanded', 'false'); current.focus(); current = null; }
      });
    });
    /* when the drawer is closed, reset to the top list */
    var details = root.closest('details');
    if (details) {
      details.addEventListener('toggle', function () {
        if (details.open) return;
        root.querySelectorAll('.kbf-mm-m__panel').forEach(function (p) { p.hidden = true; });
        root.classList.remove('is-sub');
        current = null;
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-kbf-mm]').forEach(initDesktop);
    document.querySelectorAll('[data-kbf-mm-mobile]').forEach(initMobile);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
